import isEqual from "lodash/isEqual";

import { Variables } from "~/types/rbp-request-handler";

import { SHOP_FILTER_DROPDOWN_QUERY } from "./shop-filter.const";

export const isStoreOnlyDropdownQuery = (efq: Variables["efq"]): boolean => {
  if (!efq) {
    return false;
  }

  const salesChannelValues = efq?.salesChannel?.values;

  const isEqualQuery = isEqual(
    salesChannelValues,
    SHOP_FILTER_DROPDOWN_QUERY.productsInStore,
  );

  return isEqualQuery;
};
